import { types } from "../types/types";

const initial = {
  solicitudes: [],
  historialActual: [],
  solicitudActiva: null,
  loading: false,
  creandoSolicitud: false,
  mensajesNoLeidos: 0,
  ultimosMensajes: {}, // { solicitudId: { comentario, fechaCreacion, usuarioNombre } }
  error: null,
  // Estados para archivos
  archivosActuales: [],
  loadingArchivos: false,
  subiendoArchivo: false
};

export const solicitudesReducer = (state = initial, action) => {
  switch (action.type) {
    case types.storeSolicitudes:
      return {
        ...state,
        solicitudes: action.payload,
        loading: false
      };
      
    case types.storeHistorialSolicitud:
      return {
        ...state,
        historialActual: action.payload,
        loading: false
      };
      
    case types.setLoadingSolicitudes:
      return {
        ...state,
        loading: action.payload
      };
      
    case types.setCreandoSolicitud:
      return {
        ...state,
        creandoSolicitud: action.payload
      };
      
    case types.addMensajeSolicitud:
      return {
        ...state,
        historialActual: [...state.historialActual, action.payload]
      };
      
    case types.setSolicitudActiva:
      return {
        ...state,
        solicitudActiva: action.payload
      };
      
    case types.setMensajesNoLeidos:
      return {
        ...state,
        mensajesNoLeidos: action.payload
      };
      
    case types.updateEstadoSolicitud:
      return {
        ...state,
        solicitudes: state.solicitudes.map(sol => 
          sol.proveedorSolicitudID === action.payload.proveedorSolicitudID 
            ? { ...sol, ...action.payload }
            : sol
        )
      };

    // Updates optimistas
    case types.addSolicitudOptimista:
      return {
        ...state,
        solicitudes: [action.payload, ...state.solicitudes]
      };

    case types.removeSolicitudOptimista:
      return {
        ...state,
        solicitudes: state.solicitudes.filter(sol => 
          sol.proveedorSolicitudID !== action.payload
        )
      };

    case types.addMensajeOptimista:
      return {
        ...state,
        historialActual: [...state.historialActual, action.payload]
      };

    case types.removeMensajeOptimista:
      return {
        ...state,
        historialActual: state.historialActual.filter(msg => 
          msg.proveedorSolicitudHistorialID !== action.payload
        )
      };

    case types.updateSolicitudEstatus:
      return {
        ...state,
        solicitudes: state.solicitudes.map(sol => 
          sol.proveedorSolicitudID === action.payload.solicitudId
            ? { ...sol, estatus: action.payload.estatus }
            : sol
        )
      };

    case types.storeUltimoMensaje:
      return {
        ...state,
        ultimosMensajes: {
          ...state.ultimosMensajes,
          [action.payload.solicitudId]: action.payload.ultimoMensaje
        }
      };

    // Cases para archivos
    case types.storeArchivosSolicitud:
      return {
        ...state,
        archivosActuales: action.payload,
        loadingArchivos: false
      };

    case types.setLoadingArchivos:
      return {
        ...state,
        loadingArchivos: action.payload
      };

    case types.setSubiendoArchivo:
      return {
        ...state,
        subiendoArchivo: action.payload
      };

    case types.addArchivoOptimista:
      return {
        ...state,
        archivosActuales: [...state.archivosActuales, action.payload]
      };

    case types.removeArchivoOptimista:
      return {
        ...state,
        archivosActuales: state.archivosActuales.filter(archivo => 
          archivo.proveedorSolicitudDocumentoID !== action.payload
        )
      };
      
    default:
      return state;
  }
};